import { Component, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PapiAuthService } from '../../../core/services/papi-auth.service';
import { ArcAngelMonitorModeService } from '../arc-angel-monitor-mode.service';
import { OrganizationUtilService } from '../../../core/services/organization-util.service';
import { SessionOptionsService } from '../../../core/services/session-option.service';
import { OrganizationService } from '../../../core/services/organization.service';
import { IllumLiveService } from '../../../core/services/illum-live.service';
import { NotificationService } from '../../../core/services/notification.service';
import { CdrGlobeService } from '../../../core/services/cdr-globe.service';
import { GtdGlobeService } from '../../../core/services/gtd-globe.service';

@Component({
  selector: 'app-logout',
  standalone: true,
  imports: [],
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.css',
})
export class LogoutComponent {
  constructor(
    private router: Router,
    public activeModal: NgbActiveModal,
    private authService: PapiAuthService,
    private modalService: NgbModal,
    private arcAngelMonitorModeService: ArcAngelMonitorModeService,
    private orgUtil: OrganizationUtilService,
    private sessionOptionsService: SessionOptionsService,
    private organizationservice: OrganizationService,
    private illumLive: IllumLiveService,
    private notificationService: NotificationService,
    @Optional() private cdrGlobeService?: CdrGlobeService,
    @Optional() private gtdGlobeService?: GtdGlobeService
  ) { }

  close(result: boolean) {
    this.activeModal.close(result);
    if (result) {
      // Clear all notifications on logout
      this.arcAngelMonitorModeService.removePoller();
      this.authService.clearCredentials();
      this.orgUtil.clearUserData();
      this.sessionOptionsService.clearAllSessionData();
      this.organizationservice.clearUserData();
      this.illumLive.clearIllumDataCache();

      // Make CDR and TD (GTD) intelligence data layers false / inactive if they exist
      if (this.cdrGlobeService) {
        if (typeof this.cdrGlobeService.toggleLayer === 'function') {
          this.cdrGlobeService.toggleLayer(false);
        }
        if (typeof this.cdrGlobeService.closeTowerDetails === 'function') {
          this.cdrGlobeService.closeTowerDetails();
        }
      }

      if (this.gtdGlobeService) {
        if (typeof this.gtdGlobeService.setLayerVisibility === 'function') {
          this.gtdGlobeService.setLayerVisibility(false);
        }
        if (typeof this.gtdGlobeService.setPanelOpen === 'function') {
          this.gtdGlobeService.setPanelOpen(false);
        }
        if (typeof this.gtdGlobeService.closeIncidentModal === 'function') {
          this.gtdGlobeService.closeIncidentModal();
        }
        if (typeof this.gtdGlobeService.resetAllFilters === 'function') {
          this.gtdGlobeService.resetAllFilters();
        }
      }

      this.modalService.dismissAll();
      this.router.navigate(['/login']);
    }
  }
}
